import { AppMapas } from './Constantes'
import dayjs from './DayjsUtil'
/**
 * @description Obtienes una fecha de vencimiento a partir de una unidad y cantidad.
 *
 * @author ana.carrasco  Hábil MX
 * @version 1.0.0, 20/12/2022
 * @param fechaEmision Fecha de inicio de un evento a partir de la cual se hará el cálculo.
 * @param unidad       Ya sea en días, meses, años, minutos u horas.
 * @param cantidad     cantidad en numero dependiendo de la unidad elegida.
 * @returns retorna la decha de vecimiento calculada tipo string.
 */
export const calcularFechaVencimiento = (
  fechaEmision: string,
  unidad: string,
  cantidad: number | null
) => {
  let fechaVencimiento = null
  if (fechaEmision && unidad && cantidad) {
    // La unidad visible del formulario se traduce a una unidad dayjs antes de calcular vencimiento.
    const unidadMapa = AppMapas.MAPA_UNIDAD_DURACION_AUTORIZACION.get(unidad)
    const fechaEmisionDayjs = dayjs(fechaEmision)
    fechaVencimiento = fechaEmisionDayjs.add(cantidad, unidadMapa).toString()
  }

  return fechaVencimiento
}
